export default __webpack_public_path__ + "static/media/ab-grey.73f8dbb4.svg";